<template>
    <div class="icon" @click="handleClick">
        <img src="../../../assets/images/winterGame/notification.png" />
        <div v-if="dotShow" class="dot"></div>
    </div>

</template>

<script>
import { checkAgentMessages } from "../../../api/winterGame";
export default {
  name:'notification',
    props:{
        routePath:{
            type: String,
            default: "",
        }
    },
    data() {
        return {
            currentCampusId:'',
            dotShow :false
        }
    },
    mounted() {
        this.setUserInfo();
    },
    methods:{
        setUserInfo() {
            const userInfoId = JSON.parse(localStorage.getItem("userInfoId"));
            if (userInfoId) {
                this.currentCampusId = userInfoId.campusId;
                this.checkAgentMessages()
            } else {
                Toast("找不到参赛信息");
            }
        },
        handleClick(){
            this.$router.push(this.routePath);
        },
        async checkAgentMessages() {
            let params = {
                param: {
                    schoolId: this.currentCampusId,
                },
            };
            let res = await checkAgentMessages(params);
            if (res.code === 0) {
                this.dotShow = res.data
            } else {
                Toast(res.message);
            }
        },
    }
}
</script>

<style lang="less" scoped>
.icon {
    position: relative;
    img{
        width: 52px;
        height: 52px;
    }
    .dot{
        position: absolute;
        top: 2px;
        right: 2px;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #dc5754;
    }
}
 
 
</style>
